// extracted by mini-css-extract-plugin
export default {"root":"hilFjFjg9jFlMOsWfK0D"};